import { render, staticRenderFns } from "./UploadFile.html?vue&type=template&id=de1967ac&scoped=true&"
import script from "./UploadFile.js?vue&type=script&lang=js&"
export * from "./UploadFile.js?vue&type=script&lang=js&"
import style0 from "./UploadFile.scss?vue&type=style&index=0&id=de1967ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1967ac",
  null
  
)

export default component.exports